
import React, { useState } from 'react';
import { CustomTooltip } from '../../reusableItems/tooltips';
import { LOAD_SECTION_UPDATE, generateColumn } from '../../../../supplementary_components/itemEditMethods';
import { addNotification, addPopup } from '../../../../supplementary_components/store';
import { ConfirmationDialogue } from '../../../forms/ConfirmationDialogue';
import { HiOutlineHome } from "react-icons/hi2";
import { CustomAddForm } from '../../../forms/CustomAddForm';
import { checkForEmptyField } from '../../../forms/Form';
import { getDropBoxFiles } from '../../../forms/input_fields/inputFieldDelegate';
import { TEMP_TRAILER_ADD_CONF } from '../../../../pages/trailers/trailerAddConf';
import { addressExtractor } from './listView';
import { LuPackagePlus, LuPackageCheck, LuParkingSquare, LuParkingCircle, LuTimerReset } from "react-icons/lu";
import { PiShippingContainer, PiShippingContainerThin, PiMapPinThin, PiListBulletsThin, PiMapPin, PiListBullets } from "react-icons/pi";
import { GoArrowSwitch } from "react-icons/go";
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import { BiSolidMessageDots, BiSolidMapPin } from "react-icons/bi";
import { FaCheck } from "react-icons/fa6";
import { TailSpin } from 'react-loading-icons'
import { sendRequest, API_ROOT } from '../../../../supplementary_components/requests';
import cloneDeep from 'lodash/cloneDeep';
import styles from './singleAction.module.scss';
import { FaUndoAlt } from "react-icons/fa";

export const GenerateIcon = (type) => {
    switch (type) {
        case "PU":
            return <LuPackagePlus />;
        case "DEL":
            return <LuPackageCheck />;
        case "shop":
            return <HiOutlineWrenchScrewdriver />;
        case "puTrailer":
            return <><PiShippingContainerThin /><FiArrowUp className={styles.suplementary} /></>;
        case "dropTrailer":
            return <><PiShippingContainerThin /><FiArrowDown className={styles.suplementary} /></>;
        case "swapTrailer":
            return <><PiShippingContainerThin /><GoArrowSwitch className={styles.suplementary} /></>;
        case "yard":
            return <PiMapPinThin />;
        case "park":
            return <LuParkingSquare />;
        case "homeTime":
            return <HiOutlineHome  />;
        case "reset":
            return <LuTimerReset />;
        case "custom":
            return <PiListBulletsThin />;
        
        case "thick_puTrailer":
            return <PiShippingContainer />;
        case "thick_dropTrailer":
            return <PiShippingContainer />;
        case "thick_swapTrailer":
            return <PiShippingContainer />;
        case "thick_shop":
            return <HiOutlineWrenchScrewdriver />;
        case "thick_yard":
            return <PiMapPin />
        case "thick_custom":
            return <PiListBullets />;
        case "thick_park":
            return <LuParkingCircle />;
        default:
            return <PiListBullets />
    }
}

export const SingleAction = ({taskList, setTasks, index, spaceOnRight, orderNumber, notDispatched, atTheLocation, action, onSite, truckId, statusChangableActionIndex, customBackgroundColor, showTooltip, dispatchingRequired}) =>{
    const [loading, setLoading] = useState(false);
    const [reverting, setReverting] = useState(false);
    let detailedInfo = null;
    if(showTooltip){
        const time = taskList[orderNumber].apptTime ? taskList[orderNumber].apptTime : '';
        const date = taskList[orderNumber].apptDate ? taskList[orderNumber].apptDate.substr(0, 5) : '';
        const address = addressExtractor(taskList[orderNumber].address, "cityStatePost");
        
        let customTaskDesc = null;
        try {
            if(taskList[orderNumber].actions[0].type === 'custom'){
                customTaskDesc = taskList[orderNumber].actions[0].desc
            }
        } catch (error) {}
        detailedInfo = customTaskDesc ? `${customTaskDesc}\n` : ''; 
        detailedInfo += address ?  `${date || time ? `${date} ${time}\n`:""}${address.city}, ${address.state}${address.postalCode ? `,${address.postalCode}`:''}` : '';
    }
    
    return <span className={`${styles.actionIcon} ${notDispatched ? styles.notDispatched : atTheLocation ? (action.type === "homeTime" || action.type === "reset" || action.type === "custom") ? styles.onSitePurple : styles.onSite : styles.regular}`} 
        style={{right: spaceOnRight || "0px", 
                marginRight: `${index ? -index * 3.55 : 0}rem`, 
                backgroundColor : !notDispatched && !atTheLocation && customBackgroundColor ? customBackgroundColor : "",
            }}
        >
        
        {GenerateIcon(action.type)} 
        <div className={`${styles.actionStatusChanger} ${styles.proceed} ${notDispatched || (orderNumber === 0 && index=== statusChangableActionIndex) ? styles.actionStatusChangerButton:""}`}
        style={{display:loading?"grid":"",
            backgroundColor : notDispatched ? "var(--bg)" : atTheLocation ? 'var(--main-color)' : "var(--bg)" ,
            border: (notDispatched || !onSite)  ? "thin solid var(--main-color)":""
        }}
        onClick={()=>{
            if(reverting)return;
            setLoading(true);
            const tasksCopy = [...taskList];
            const taskClone = cloneDeep(tasksCopy[orderNumber])
            const completeTask = (removeTrailer) => {
                taskClone.actions[index].completed = true;
                sendRequest('PATCH', `${API_ROOT}trucks/updateTask/${truckId}?${removeTrailer ? "removeTrailer=True" : ""}`, null, (response)=>{
                    setLoading(false);
                    tasksCopy[orderNumber].actions[index].completed = true;
                    if(tasksCopy[orderNumber].actions.length === index+1){
                        tasksCopy.splice(orderNumber, 1);
                    }
                    setTasks(tasksCopy, response);
                }, ()=>{
                    setLoading(false);
                    addNotification({message:`Something went wrong`, type:'alert'});
                }, taskClone);
            }
            if(notDispatched){
                if(taskClone.actions.length === 1 && (taskClone.actions[0].type === "homeTime" || taskClone.actions[0].type === "reset" || taskClone.actions[0].type === "custom")){
                    changeTaskToOnSite(taskClone, tasksCopy, truckId, orderNumber, setLoading, setTasks, index, true);
                }else{
                    taskClone.actions[index].dispatched = true;
                    sendRequest('PATCH', `${API_ROOT}trucks/updateTask/${truckId}`, null, (response)=>{
                        setLoading(false);
                        tasksCopy[orderNumber].actions[index].dispatched = true;
                        setTasks(tasksCopy, response);
                    }, ()=>{
                        setLoading(false);
                        addNotification({message:`Something went wrong`, type:'alert'});
                    }, taskClone);
                }
            }else if(!atTheLocation){
                if(taskClone.actions.length === 1 && (taskClone.actions[0].type === "park" )){
                    completeTask();
                }else{
                    changeTaskToOnSite(taskClone, tasksCopy, truckId, orderNumber, setLoading, setTasks, index, false);
                }
            }else{
                if(taskClone.loadId && taskClone.loadStopIndex === 0 && taskClone.actions[index].loadAction){
                    let lastStopAppDate;
                    for(const task of taskList){
                        if(task.loadId === taskClone.loadId){
                            lastStopAppDate = task.apptDate;
                        }
                    }
                    checkIfLoadHasTrailer(taskClone.loadId, taskClone.apptDate, lastStopAppDate, completeTask, setLoading);
                }else{
                    
                    if(LoadsLastStopIndex(taskClone.loadId, taskList) === taskClone.id && taskClone.actions[index].loadAction ){
                        suggestToUploadBOLIfNotAttached(taskClone.loadId, ()=>{
                            if(taskClone.actions[index].desc === "hook&drop"){
                                ConfirmUnhooking(completeTask);
                            }else{
                                completeTask();
                            }
                        })
                    }else{
                        completeTask();
                    }
                }
            }
        }}
        >
            {loading ? 
            <TailSpin stroke={`${onSite?"var(--bg)":"var(--main-color)"}`} strokeWidth="0.2rem"  speed = {1} />  : 
            notDispatched ? <BiSolidMessageDots style={{marginBottom:"-0.17rem"}} /> : 
            onSite ? <FaCheck /> : 
            <BiSolidMapPin />}
        </div>
        <div className={`${styles.actionStatusChanger} ${styles.revert} ${(dispatchingRequired && !notDispatched) || onSite ? styles.actionStatusChangerButton:""}`}
        style={{display:reverting?"grid":""}}
        onClick={()=>{
            if(loading)return;
            setReverting(true);
            const tasksCopy = [...taskList];
            const taskClone = cloneDeep(tasksCopy[orderNumber]);
            if(taskClone.onSite){
                taskClone.onSite = false;
                if((taskClone.actions[index].type === "homeTime" || taskClone.actions[index].type === "reset" || taskClone.actions[index].type === "custom")){
                    taskClone.actions[index].dispatched = false;
                }
            }else if(taskClone.actions[index].dispatched){
                taskClone.actions[index].dispatched = false;
            }
            sendRequest('PATCH', `${API_ROOT}trucks/revertTaskStatus/${truckId}`, null, (response)=>{
                setReverting(false);
                tasksCopy[orderNumber] = taskClone;
                setTasks(tasksCopy, response);
            }, null, taskClone);
            
        }}
        >
            {reverting ? 
            <TailSpin stroke={'var(--gray)'} strokeWidth="0.2rem"  speed = {1} />
            :<FaUndoAlt />}
            
        </div>
        {detailedInfo ? <CustomTooltip info={detailedInfo} marginTop={"2.5rem"} xDisposition="-2.5rem" customClassName={styles.tooltip} /> : null}
    </span>
}


function changeTaskToOnSite(taskClone, tasksCopy, truckId, orderNumber, setLoading, setTasks, index, simultaneouslyDispatched){
    if(simultaneouslyDispatched)taskClone.actions[index].dispatched = true;
    taskClone.onSite = true;
    sendRequest('PATCH', `${API_ROOT}trucks/updateTask/${truckId}`, null, (response)=>{
        setLoading(false);
        if(simultaneouslyDispatched)tasksCopy[orderNumber].actions[index].dispatched = true;
        tasksCopy[orderNumber].onSite = true;
        setTasks(tasksCopy, response);
    }, ()=>{
        setLoading(false);
        addNotification({message:`Something went wrong`, type:'alert'});
    }, taskClone);
}
export function checkIfLoadHasTrailer(loadId, loadStartDate, lastStopAppDate, completeTask, setLoading){    
    sendRequest("GET", `${API_ROOT}loads/hasTrailer/${loadId}`, null, (val)=>{
        if(val.hasTrailer){
            completeTask();
        }else{
            setLoading(false);
            
            try {
                ObtainTrailerNumberForTheLoad(loadId, loadStartDate, completeTask, lastStopAppDate, val)
            } catch (error) {
                console.error(error)
            }
        }
    }, (e)=>{
        addNotification({message:e && e.customError?e.customError:`Something went wrong`, type:'alert'});
        setLoading(false);
    })
}
export const ObtainTrailerNumberForTheLoad = (loadId, firstApptDate, completeTask, lastStopAppDate, val) => {
    LOAD_SECTION_UPDATE(()=>{completeTask()}, loadId, () => {
        return [
        generateColumn({id: loadId, currentTrailer: null}, true, 'Assign Trailer For This Load', [['currentTrailer','trailerNumber']], {
        mandatory: true,
        suggestionsEnabled : true,
        suggestionsLink : API_ROOT+`trailers/trailersByNumberAndAvailablityForDates?dates=${firstApptDate}-${lastStopAppDate}&currentTrailer=''&loadType=${val.loadType}&pattern=`,
        addNewButton: {label:'Add Temporary Trailer', configuration:TEMP_TRAILER_ADD_CONF},
        prefillConditioning:(val)=>{
            return {val: val, index:3};
        },
        dataValueRequired : true,
        autoComplete : 'off',
        displayValueGenerator : (rawValue)=>{return rawValue['trailerNumber']},
        // displayValueToRawValue: (value)=>{return value.substr(0, value.indexOf('(')).trim()},
        availableOptionDefiningColumnName : 'available',
        twoPartValue : {
            mainPart : rawData => rawData['available'] ? rawData['trailerNumber'] : '',
            subPart:  rawData => `${!rawData['available'] ? `${rawData['trailerNumber']} (Conflicting Load: #${rawData['loadNumber']})`: rawData['loadNumber'] !== "" ? `(Assigned to Load ${rawData['loadNumber']})` : rawData['currentTruck'] !== null && rawData['currentTruck'] !== ""   ? `(Current Truck ${rawData['currentTruck']})` : "" }`
        },
        afterMinimumChars:2,
        checksMust:true,
        checks : [
            async (value, column, target) => new Promise(resolve => {
                try {
                    if(value === '' || target.getAttribute('data-value') === 'null'){
                        resolve();
                        return;
                    }
                     
                    const parseVal = JSON.parse(target.getAttribute('data-value'));
                    const currentTruck = parseVal.currentTruck;
                    const currentTrailer = parseVal.trailerNumber;
                    
                    if(currentTruck !== null){
                        addPopup({
                            content:ConfirmationDialogue, 
                            popupData: {
                                confirmationDialogue:true,
                                oneButton: false,
                                action:(postResultAction)=>{
                                    postResultAction(true);
                                },
                                cancelAction:(closePopup)=>{
                                    target.setAttribute('data-value', ``);
                                    target.value = "";
                                    closePopup()
                                },
                                name:"Confirm",
                                formTitle:"Confirm Unhooking",
                                submitTitle:"Continue",
                                message:`Trailer ${currentTrailer} will be UNHOOKED from Truck ${currentTruck}. Continue?`
                            }, 
                            postSuccessAction: ()=>{
                            }, 
                            EZCloseAllowed:false
                        })
                    }
                    resolve();
                } catch (error) {
                    console.log(error);
                }
                resolve();
            }),
        ]
        }),
    ]}, "Trailer Not Assigned")
}
const LoadsLastStopIndex = (loadId, taskList) => {
    let lastTaskId = "";
    for(const task of taskList){
        if(task.loadId === loadId){
            lastTaskId = task.id
        }
    }
    return lastTaskId;
}
export function suggestToUploadBOLIfNotAttached(loadId, nextAction, popupAdded){
    sendRequest("GET", API_ROOT+"loads/hasBOL?loadId="+loadId, null, (res)=>{
        if(!res){
            const InputFormData = {columns: [
                {
                    label: "File",
                    name: 'selectedFile',
                    type: 'dropBox',
                    multiple: true,
                    imageEditor: true,
                    mandatory:true,
                    file: null,
                    files: [],
                },
            ]}
            if(popupAdded){
                popupAdded();
            }
            addPopup({
                content:CustomAddForm, 
                popupData: {
                    action:(event, postResultAction)=>{
                        event.preventDefault();
                        if (checkForEmptyField(InputFormData, event)){return;}
                        const dropColumn = InputFormData.columns.find((clmn) => clmn.type === 'dropBox');
                        const selectedFiles = getDropBoxFiles(dropColumn);
                        if (!selectedFiles.length) {
                            return;
                        }
                        const companyHeaders = {companyId:  parseInt(localStorage.getItem("currentCompanyId"))};
                        const uploadAt = (index) => {
                            if (index >= selectedFiles.length) {
                                postResultAction(true);
                                nextAction();
                                return;
                            }
                            const body = new FormData();
                            body.append("file", selectedFiles[index]);
                            body.append("fileName", selectedFiles[index].name);
                            body.append("loadId", loadId);
                            body.append("fileType", 'POD');
                            sendRequest('POST', API_ROOT+'loads/addFile',null,()=>{
                                    uploadAt(index + 1);
                                }, ()=>{
                                    postResultAction(false);
                                    addNotification({
                                        message: index > 0
                                            ? `Uploaded ${index} of ${selectedFiles.length} files, then something went wrong`
                                            : `Something went wrong`,
                                        type:'alert'
                                    });
                                    nextAction();
                                }, body, companyHeaders,(body)=>{return body}, false);
                        };
                        uploadAt(0);
                    },
                    name:"Add",
                    formTitle:"Add POD",
                    submitTitle:"Add",
                    method:"POST",
                    columns: InputFormData['columns'],
                    skipLabel: "Skip",
                    skipMethod: nextAction

                }, 
                EZCloseAllowed:true
            })
            
        }else{
            nextAction();
        }
    }, ()=>{
        nextAction();
    })
    
}
export const ConfirmUnhooking = (completeTask) => { 
    addPopup({
        content:ConfirmationDialogue, 
        popupData: {
            confirmationDialogue:true,
            oneButton: false,
            action:(postResultAction)=>{
                completeTask(true)
                postResultAction(true);
            },
            cancelAction:(closePopup)=>{
                // target.setAttribute('data-value', ``);
                // target.value = "";
                completeTask()
                closePopup()
                
            },
            name:"Confirm",
            formTitle:"Delivery Type (Drop)",
            submitTitle:"Unhook",
            cancelButtonText:"Keep It",
            message:`Unhook the trailer from the truck?`
        }, 
        postSuccessAction: ()=>{
            
        }, 
        EZCloseAllowed:false
    })
}